"use client";

import { useTruncate } from "hooks/use-truncate";

import { SymbolBadge } from "ui/widget/badge";

export const RelatedSymbols = ({ symbols }: { symbols: string[] }) => {
  const { ref } = useTruncate<HTMLDivElement>();
  return (
    <div ref={ref} className="flex max-h-10 w-full flex-wrap gap-2">
      {symbols.map((symbol, index) => (
        <SymbolBadge
          key={index}
          className="h-6 w-[54px] border-[1px] border-sky-200"
        >
          {symbol}
        </SymbolBadge>
      ))}
      <SymbolBadge className="h-6 w-[54px] border-[1px] border-sky-200">
        ...
      </SymbolBadge>
    </div>
  );
};
